import {Injectable, signal} from '@angular/core';
import {BloggerGroupsData} from "../types/blogger-groups.types";

@Injectable({
  providedIn: 'root'
})
export class BloggerGroupsStateService {
  private _bloggerGroups = signal<Array<BloggerGroupsData>>([]);
  public bloggerGroups = this._bloggerGroups.asReadonly();

  public setBloggerGroups(bloggerGroups: Array<BloggerGroupsData>) {
    this._bloggerGroups.set(bloggerGroups);
  }

  public updateBloggerGroups(bloggerGroup: BloggerGroupsData) {
    this._bloggerGroups.update(currentGroups => {
      const index = currentGroups.findIndex(g => g.id === bloggerGroup.id);

      if (index !== -1) {
        const updatedGroups = [...currentGroups];
        updatedGroups[index] = bloggerGroup;
        return updatedGroups;
      }

      return currentGroups;
    });
  }
}
